import {
  TranslationAction,
  TranslationState,
} from "@pages:app/document-translation/types";

export function translationReducer(
  state: TranslationState,
  action: TranslationAction,
): TranslationState {
  switch (action.type) {
    case "START_TRANSLATION":
      return {
        status: "translating",
        file: action.file,
        filename: action.file.name,
        language: action.language,
      };

    case "TRANSLATION_SUCCESS":
      if (state.status !== "translating") return state;
      return {
        status: "success",
        translatedFile: {
          blob: action.blob,
          filename: action.filename,
          originalFilename: state.filename,
          size: action.blob.size,
          timestamp: new Date(),
          language: state.language,
        },
      };

    case "TRANSLATION_ERROR":
      if (state.status !== "translating") {
        return {
          status: "error",
          message: action.message,
          canRetry: true,
          // Empty so ErrorCard renders the localized "unknown file" fallback.
          filename: "",
          fileSize: 0,
        };
      }
      return {
        status: "error",
        message: action.message,
        canRetry: true,
        filename: state.filename,
        fileSize: state.file.size,
        language: action.language,
      };

    case "RESET":
      return { status: "idle" };

    case "DOWNLOAD":
      // Stay in success state
      return state;

    default:
      return state;
  }
}
